// extracted by mini-css-extract-plugin
module.exports = {"LineWrapper":"QuestStatistic_LineWrapper__3W4u3","Title":"QuestStatistic_Title__10iZe"};